import React, { FC, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import RecoverySendEmailForm from 'pages/RecoveryPassword/RecoverySendEmailForm';
import Appeal from 'shared/components/Appeal/DefaultRenderer';
import ArrowBackLink from 'shared/components/ArrowBackLink';
import OnboardingContentContainer from 'shared/components/OnboardingContentContainer';
import RecoveryCongrats from 'pages/RecoveryPassword/RecoveryCongrats';
import ResponseFailure from 'shared/components/ResponseFailure';
import { urls } from 'core/appUrls';
import { parseResetTokenFromSearch } from 'core/passwordRecovery';
import styles from './RecoveryPassword.module.scss';

const RecoveryPassword: FC = () => {
	const [sentEmailSuccess, setSentEmailSuccess] = useState(false);
	const [responseError, setResponseError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const location = useLocation();
	const history = useHistory();

	const resetToken = useMemo(() => parseResetTokenFromSearch(location.search), [location.search]);

	useEffect(() => {
		if (!resetToken) {
			return;
		}

		history.replace(`${urls.resetPassword}?token=${encodeURIComponent(resetToken)}`);
	}, [history, resetToken]);

	if (responseError) {
		return (
			<OnboardingContentContainer>
				<ResponseFailure
					message={errorMessage}
					buttonTitle="Back to login"
					buttonClickHandler={() => history.push(urls.loginSuperAdmin)}
				/>
			</OnboardingContentContainer>
		);
	}

	if (resetToken) {
		return null;
	}

	return (
		<OnboardingContentContainer>
			<div className={styles.content}>
				<Appeal styleCongrats={sentEmailSuccess} stylePensive={true}>
					{sentEmailSuccess ? (
						<RecoveryCongrats title="A recovery password email was sent. Please check your email and follow the instructions." />
					) : (
						<>
							<div style={{ position: 'absolute', top: 24, left: 24 }}>
								<ArrowBackLink />
							</div>
							<RecoverySendEmailForm
								setSentEmailSuccess={setSentEmailSuccess}
								setResponseError={setResponseError}
								setErrorMessage={setErrorMessage}
							/>
						</>
					)}
				</Appeal>
			</div>
		</OnboardingContentContainer>
	);
};

export default RecoveryPassword;
